import {takeLatest, select, put} from 'redux-saga/effects'
import { IAppState } from '../store/state.interface.web'
import { loggedInUser, updateMeToken } from '../auth/index.web'

export function * startupSagas({setHeader}: any, {key = '', payload}: any) {
  try {
    try {
      const store: IAppState = yield select()
      const { token } = store.auth
      if (token) {
        setHeader('Authorization', `Bearer ${token}`)
        yield put(updateMeToken.success({
          token
        }))
        yield put(loggedInUser())
      }
    } catch (e) {}
    yield
  } catch (err) {
    console.error(err)
  }
}

export default (api: any) => {
  return [
    takeLatest('persist/REHYDRATE', startupSagas, {setHeader: api.setHeader})
  ]
}
